import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { clearAutoRefresh } from "../utils/tokenRefresh";

const Navigation: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAutoRefresh();
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <nav className="nav-bar">
      <div className="nav-brand">Days</div>
      <div className="nav-links">
        <NavLink to="/" end className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
          Today
        </NavLink>
        <NavLink to="/goals" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
          Goals
        </NavLink>
        <NavLink to="/calendar" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
          Calendar
        </NavLink>
      </div>
      <button className="nav-logout" onClick={handleLogout}>
        Log out
      </button>
    </nav>
  );
};

export default Navigation;
